import api, { buildService } from './index'

export default {
  ...buildService('events'),
  markAsSeen: eventtIds => api.post('events/mark-as-seen', eventtIds)
}
